interface FrequencyFiltersProps {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
  counts: Record<string, number>;
}

const filterDefs = [
  { key: 'todas', label: 'Todas', icon: 'ri-radar-line' },
  { key: 'libres', label: 'Libres', icon: 'ri-checkbox-blank-circle-line' },
  { key: 'asignadas', label: 'Asignadas', icon: 'ri-link' },
  { key: 'reservadas', label: 'Reservadas', icon: 'ri-bookmark-line' },
  { key: 'bloqueadas', label: 'Bloqueadas', icon: 'ri-forbid-line' },
];

export default function FrequencyFilters({ activeFilter, onFilterChange, counts }: FrequencyFiltersProps) {
  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {filterDefs.map((f) => {
        const isActive = activeFilter === f.key;
        const count = counts[f.key] ?? 0;
        return (
          <button
            key={f.key}
            onClick={() => onFilterChange(f.key)}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
              isActive
                ? 'bg-foreground-950 text-background-50'
                : 'bg-background-50 text-foreground-500 border border-background-200 hover:border-foreground-300 hover:text-foreground-700'
            }`}
          >
            <i className={`${f.icon} text-[11px]`}></i>
            {f.label}
            <span className={`ml-0.5 ${isActive ? 'text-background-50/60' : 'text-foreground-300'} text-[10px]`}>
              {count.toLocaleString()}
            </span>
          </button>
        );
      })}
    </div>
  );
}